const policyVersions = {
  terms: {
    en: [
      {
        version: '20160624',
        url: 'static/policy-mds/terms/20160624.en-US.md',
      },
      {
        version: '20150824',
        url: 'static/policy-mds/terms/20150824.en-US.md',
      },
      {
        version: '20131010',
        url: 'static/policy-mds/terms/20131010.en-US.md',
      },
      {
        version: '20130401',
        url: 'static/policy-mds/terms/20130401.en-US.md',
      },
      {
        version: '20121002',
        url: 'static/policy-mds/terms/20121002.en-US.md',
      },
      {
        version: '20120720',
        url: 'static/policy-mds/terms/20120720.en-US.md',
      },
    ],
    ko: [
      {
        version: '20131010',
        url: 'static/policy-mds/terms/20131010.ko-KR.md',
      },
      {
        version: '20130401',
        url: 'static/policy-mds/terms/20130401.ko-KR.md',
      },
      {
        version: '20121002',
        url: 'static/policy-mds/terms/20121002.ko-KR.md',
      },
      {
        version: '20120720',
        url: 'static/policy-mds/terms/20120720.ko-KR.md',
      },
    ],
    ja: [
      {
        version: '20150730',
        url: 'static/policy-mds/terms/20150730.ja-JP.md',
      },
      {
        version: '20150605',
        url: 'static/policy-mds/terms/20150605.ja-JP.md',
      },
    ],
    'zh-TW': [
      {
        version: '20150910',
        url: 'static/policy-mds/terms/20150910.zh-TW.md',
      },
    ],
    'en-HK': [
      {
        version: '20150901',
        url: 'static/policy-mds/terms/20150901.en-HK.md',
      },
    ],
    'zh-CN': [
      {
        version: '20150901',
        url: 'static/policy-mds/terms/20150901.zh-CN.md',
      },
    ],
    es: [
      {
        version: '20150824',
        url: 'static/policy-mds/terms/20150824.en-US.md',
      },
      {
        version: '20131010',
        url: 'static/policy-mds/terms/20131010.en-US.md',
      },
      {
        version: '20130401',
        url: 'static/policy-mds/terms/20130401.en-US.md',
      },
      {
        version: '20121002',
        url: 'static/policy-mds/terms/20121002.en-US.md',
      },
      {
        version: '20120720',
        url: 'static/policy-mds/terms/20120720.en-US.md',
      },
    ],
    tr: [
      {
        version: '20150824',
        url: 'static/policy-mds/terms/20150824.en-US.md',
      },
      {
        version: '20131010',
        url: 'static/policy-mds/terms/20131010.en-US.md',
      },
      {
        version: '20130401',
        url: 'static/policy-mds/terms/20130401.en-US.md',
      },
      {
        version: '20121002',
        url: 'static/policy-mds/terms/20121002.en-US.md',
      },
      {
        version: '20120720',
        url: 'static/policy-mds/terms/20120720.en-US.md',
      },
    ],
  },
  operation: {
    en: [
      {
        version: '20131010',
        url: 'static/policy-mds/operation/20131010.en-US.md',
      },
      {
        version: '20130401',
        url: 'static/policy-mds/operation/20130401.en-US.md',
      },
    ],
    ko: [
      {
        version: '20131010',
        url: 'static/policy-mds/operation/20131010.ko-KR.md',
      },
      {
        version: '20130401',
        url: 'static/policy-mds/operation/20130401.ko-KR.md',
      },
    ],
    ja: [
      {
        version: '20150605',
        url: 'static/policy-mds/operation/20150605.ja-JP.md',
      },
    ],
    'zh-TW': [
      {
        version: '20150910',
        url: 'static/policy-mds/operation/20150910.zh-TW.md',
      },
    ],
    es: [
      {
        version: '20131010',
        url: 'static/policy-mds/operation/20131010.en-US.md',
      },
      {
        version: '20130401',
        url: 'static/policy-mds/operation/20130401.en-US.md',
      },
    ],
    tr: [
      {
        version: '20131010',
        url: 'static/policy-mds/operation/20131010.en-US.md',
      },
      {
        version: '20130401',
        url: 'static/policy-mds/operation/20130401.en-US.md',
      },
    ],
  },
  privacy: {
    en: [
      {
        version: '20160624',
        url: 'static/policy-mds/privacy/20160624.en-US.md',
      },
      {
        version: '20150910',
        url: 'static/policy-mds/privacy/20150910.en-US.md',
      },
      {
        version: '20150824',
        url: 'static/policy-mds/privacy/20150824.en-US.md',
      },
      {
        version: '20131010',
        url: 'static/policy-mds/privacy/20131010.en-US.md',
      },
      {
        version: '20130401',
        url: 'static/policy-mds/privacy/20130401.en-US.md',
      },
      {
        version: '20121002',
        url: 'static/policy-mds/privacy/20121002.en-US.md',
      },
      {
        version: '20120720',
        url: 'static/policy-mds/privacy/20120720.en-US.md',
      },
    ],
    ko: [
      {
        version: '20160919',
        url: 'static/policy-mds/privacy/20160919.ko-KR.md',
      },
      {
        version: '20160624',
        url: 'static/policy-mds/privacy/20160624.ko-KR.md',
      },
      {
        version: '20131010',
        url: 'static/policy-mds/privacy/20131010.ko-KR.md',
      },
      {
        version: '20130401',
        url: 'static/policy-mds/privacy/20130401.ko-KR.md',
      },
      {
        version: '20121002',
        url: 'static/policy-mds/privacy/20121002.ko-KR.md',
      },
      {
        version: '20120720',
        url: 'static/policy-mds/privacy/20120720.ko-KR.md',
      },
    ],
    ja: [
      {
        version: '20160624',
        url: 'static/policy-mds/privacy/20160624.ja-JP.md',
      },
      {
        version: '20160530',
        url: 'static/policy-mds/privacy/20160530.ja-JP.md',
      },
      {
        version: '20150605',
        url: 'static/policy-mds/privacy/20150605.ja-JP.md',
      },
    ],
    'zh-TW': [
      {
        version: '20160624',
        url: 'static/policy-mds/privacy/20160624.zh-TW.md',
      },
      {
        version: '20150910',
        url: 'static/policy-mds/privacy/20150910.zh-TW.md',
      },
    ],
    'zh-CN': [
      {
        version: '20150901',
        url: 'static/policy-mds/privacy/20150901.zh-CN.md',
      },
    ],
    'en-HK': [
      {
        version: '20150901',
        url: 'static/policy-mds/privacy/20150901.en-HK.md',
      },
    ],
    es: [
      {
        version: '20150910',
        url: 'static/policy-mds/privacy/20150910.en-US.md',
      },
      {
        version: '20150824',
        url: 'static/policy-mds/privacy/20150824.en-US.md',
      },
      {
        version: '20131010',
        url: 'static/policy-mds/privacy/20131010.en-US.md',
      },
      {
        version: '20130401',
        url: 'static/policy-mds/privacy/20130401.en-US.md',
      },
      {
        version: '20121002',
        url: 'static/policy-mds/privacy/20121002.en-US.md',
      },
      {
        version: '20120720',
        url: 'static/policy-mds/privacy/20120720.en-US.md',
      },
    ],
    tr: [
      {
        version: '20160624',
        url: 'static/policy-mds/privacy/20160624.en-US.md',
      },
      {
        version: '20150910',
        url: 'static/policy-mds/privacy/20150910.en-US.md',
      },
      {
        version: '20150824',
        url: 'static/policy-mds/privacy/20150824.en-US.md',
      },
      {
        version: '20131010',
        url: 'static/policy-mds/privacy/20131010.en-US.md',
      },
      {
        version: '20130401',
        url: 'static/policy-mds/privacy/20130401.en-US.md',
      },
      {
        version: '20121002',
        url: 'static/policy-mds/privacy/20121002.en-US.md',
      },
      {
        version: '20120720',
        url: 'static/policy-mds/privacy/20120720.en-US.md',
      },
    ],
  },
};

export default policyVersions;



// WEBPACK FOOTER //
// ./src/config/policyVersions.js